// src/app/redux/reducers/cataloguesReducer.js

import {
    SET_CATALOGUES_LOADING,
    SET_CATALOGUES_ERROR,
    FETCH_CATALOGUES_SUCCESS,
    FETCH_CATALOGUES_FAIL,
    CREATE_CATALOGUE_FAIL,
    UPDATE_CATALOGUE_FAIL,
    DELETE_CATALOGUE_SUCCESS,
    DELETE_CATALOGUE_FAIL,
} from "../actions/cataloguesActions";

const initialState = {
    loading: false,
    error: null,
    catalogues: [],
};

export default function cataloguesReducer(state = initialState, action) {
    switch (action.type) {
        case SET_CATALOGUES_LOADING:
            return { ...state, loading: action.payload };

        case SET_CATALOGUES_ERROR:
            return { ...state, error: action.payload };

        case FETCH_CATALOGUES_SUCCESS:
            return { ...state, catalogues: action.payload || [], error: null };

        case FETCH_CATALOGUES_FAIL:
        case CREATE_CATALOGUE_FAIL:
        case UPDATE_CATALOGUE_FAIL:
        case DELETE_CATALOGUE_FAIL:
            return { ...state, error: action.payload };

        case DELETE_CATALOGUE_SUCCESS:
            return { ...state, catalogues: state.catalogues.filter((c) => c.id !== action.payload), error: null };

        default:
            return state;
    }
}
